export default __webpack_public_path__ + "static/media/element_spec_27.935843fd.webp";